/** @file Two-step destructive button: the first click arms it, the second runs the action. */
import { useState } from 'react';
import './tokens.css';
import './ConfirmButton.css';

/** Props of ConfirmButton; both labels are already translated. */
export interface ConfirmButtonProps {
  label: string;
  confirmLabel: string;
  onConfirm: () => void;
  disabled?: boolean;
}

/** Leaving the button disarms it; the second half of a double-click (event.detail > 1) never confirms. */
export function ConfirmButton({ label, confirmLabel, onConfirm, disabled = false }: ConfirmButtonProps) {
  const [armed, setArmed] = useState(false);
  const onClick = (event?: { detail: number }): void => {
    if (!armed) {
      setArmed(true);
      return;
    }
    // The second or later click of one double-click (detail > 1) is not a deliberate confirmation.
    if ((event?.detail ?? 1) > 1) return;
    setArmed(false);
    onConfirm();
  };
  return (
    <button type="button" className={armed ? 'p2-confirm p2-confirm-armed' : 'p2-confirm'} disabled={disabled} onBlur={() => { setArmed(false); }} onClick={onClick}>
      {armed ? confirmLabel : label}
    </button>
  );
}
